<template>
  <InvoiceReport
    :columns="columns"
    :form-store="formStore"
    new-button-title="New Invoice"
    new-button-url="/dashboard#/invoices/new"
    :export-filename="exportFileName"
    :enable-dropdown="true"
    :customers="customers"
    :dropdown-options="[ { 'All Invoices': '' },
                         { 'Paid': 'paid' },
                         { 'Outstanding': 'outstanding' },
                         { 'Overdue': 'overdue' },
                         { 'Void': 'void' }]"
    @dropdownChanged="dropdownChanged($event)" />
</template>

<script>
import InvoiceReportRevenuesReceivablesMixin from "./InvoiceReportRevenuesReceivablesMixin";
import InvoiceReport from "./InvoiceReport.vue";
import { selectColumns } from "./RevenuesReceivablesReportColumns";
import InvoiceReportFormStore from "./InvoiceReportFormStore";
import CustomerStore from "../Customer/CustomerStore";

let invoiceReportFormStore = new InvoiceReportFormStore("invoices");

const responseStore = { customers: [] };

const fetchResource = async (to, from, next) => {
  responseStore.customers = await CustomerStore.fetchAll();

  next();
};

export default {
  name: "InvoiceReportRevenuesReceivables",

  title () {
    return `Invoices - ${Dashboard.currentTenant.name}`;
  },

  components: {
    InvoiceReport
  },

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  mixins: [InvoiceReportRevenuesReceivablesMixin],

  data () {
    return {
      formStore: invoiceReportFormStore,
      columns: selectColumns(),
      exportFileName: "revenues-and-receivables",
      responseStore: responseStore
    };
  },

  computed: {
    customers () {
      return this.responseStore.customers.collection;
    }
  },

  methods: {
    dropdownChanged (e) {
      if (e) {
        this.exportFileName = e;
      } else {
        this.exportFileName = "revenues-and-receivables";
      }
    }
  }
};
</script>
